export default __webpack_public_path__ + "b56de21055577982781fc64edb00e06e.png";